import React, {Component, Fragment} from 'react'
import Switch from 'rc-switch'
import autobind from 'auto-bind'

export default class OEETimeBasedSpeedLoss extends Component {
    id = 'OEETimeBasedSpeedLoss'
    field = 'useTimeBasedSpeedLosses'
    constructor(props) {
        super(props)
        autobind(this)

        const initialValue =
            this.props &&
            Object.prototype.hasOwnProperty.call(this.props, 'existing') &&
            this.props.existing !== undefined
                ? this.props.existing
                : false

        this.state = {
            value: initialValue,
        }

        if (this.props && this.props.cb) {
            this.props.cb('useTimeBasedSpeedLosses', initialValue)
        }
    }

    handleValueChange(value) {
        this.setState({value})

        if (this.props.cb) {
            this.props.cb('useTimeBasedSpeedLosses', value)
        }
    }

    render() {
        return (
            <Fragment>
                <label>Use time based speed loss calculation:</label>
                <Switch
                    className="custom-switch custom-switch-primary"
                    checked={this.state.value}
                    onChange={this.handleValueChange}
                />
            </Fragment>
        )
    }
}
